import React from "react";
import styles from "./LifeAt.module.css";
import { RiArrowUpSLine } from "react-icons/ri";
import { CgShapeTriangle } from "react-icons/cg";
const LifeAt = () => {
  return (
    <div
      style={{
        background: `url(./assets/team/Office_Grp_New.png)`,
        backgroundSize: "cover",

        position: "relative",
        top: "-50px",
        backgroundAttachment: "fixed",
      }}
    >
      <div className={styles.container}>
        <p className={styles.animation}>Life At Space Labs</p>
        {/* <p className={styles.animation2}>Future of Railways</p> */}
        <div className={styles.section}>
          <h6>
            Our team is comprised of experts specialized in 3D modeling and
            simulation, laser and camera- based optics, computer vision, and
            artificial intelligence. Our culture is built on respect, growth,
            and a shared passion for excellence.
          </h6>
          <h6>
            At Space-labs, we believe work should feel like a second home-where
            innovation thrives, collaboration is natural, and every voice
            matters. Join us, and be part of a company that invests in your
            success while fostering a positive, dynamic, and fulfilling
            environment.
          </h6>
        </div>
        <div
          className={styles.upArrow}
          onClick={() => {
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
        >
          <CgShapeTriangle />
          <div style={{ fontSize: "10px", padding: "0px" }}>Back To Top</div>
        </div>
      </div>
    </div>
  );
};

export default LifeAt;
